import { Injectable } from '@angular/core';
import {
  AbstractControl,
  AbstractControlOptions,
  UntypedFormBuilder,
  UntypedFormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { PrFormService } from '@app/components/pr-form/pr-form.service';
import { EstateDao } from '@app/dao/estate/estate.dao';
import { UtilsService } from '@app/providers/utils/utils.service';
import { NotificationsService } from '@app/components/notification/NotificationsService';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EaEstimationFormService {
  generateSubject: Subject<UntypedFormGroup> = new Subject();
  entityName = 'estimations';

  constructor(
    protected estateDao: EstateDao,
    protected formBuilder: UntypedFormBuilder,
    protected utilsService: UtilsService,
    protected prFormService: PrFormService,
    protected notificationsService: NotificationsService,
  ) {}

  public generate(entity: any) {
    let options: AbstractControlOptions = {};
    let elems: UntypedFormGroup[] = [];

    if (entity.estimations)
      for (let estimation of entity.estimations)
        elems.push(
          this.formBuilder.group({
            id: [estimation ? estimation.id : null],
            amount: [
              estimation ? estimation.amount : null,
              Validators.required,
            ],
            date: [estimation ? estimation.date : null, Validators.required],
            source: ['USER'],
          }),
        );

    let group = this.formBuilder.group({
      array: this.formBuilder.array(elems, Validators.nullValidator),
    });

    this.generateSubject.next(group);

    return group;
  }

  public extract(form) {
    let dto: any = {
      id: this.utilsService.emptyIsNull(form.value.id),
      amount: this.utilsService.emptyIsNull(form.value.amount),
      date: this.utilsService.toIsoDate(form.value.date),
      source: this.utilsService.emptyIsNull(form.value.source),
    };
    return dto;
  }

  public addElem(entity, form) {
    let elem = {};
    if (!entity[this.entityName]) entity[this.entityName] = [];
    entity[this.entityName].push(elem);
    form.array.push(
      this.formBuilder.group({
        id: '',
        amount: [null, Validators.required],
        date: [null, Validators.required],
        source: ['USER'],
      }),
    );
  }

  public removeElem(index, elems, entity) {
    let elem = elems.value[index];
    if (elem.id) {
      elem.accountId = entity.userId;
      this.prFormService.loading();
      /* this.estateDao.deleteExpense(entity.userId, entity.typeUrl, entity.id, elem.id).subscribe((success) => {
        this.prFormService.loaded()
        this.notificationsService.success("La supression a réussi")
      }, (errors) => {
        console.error(errors)
        this.prFormService.loaded()
        this.notificationsService.error("La supression a échoué")
      }); */
    } else {
      entity[this.entityName] = entity[this.entityName].slice(index, 1);
      elems.removeAt(index);
    }
  }
}
